<template>
  <div>
    <v-form @submit.prevent="submit">
      <v-card class="mx-auto my-8">
        <v-card-title
          ><span class="headline">Change Password</span></v-card-title
        >
        <v-card-text>
          <v-text-field
            required
            name="old_password"
            label="Current Password"
            v-model="formData.old_password"
            :type="showOldPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showOldPassword = !showOldPassword"
            :error="errors.old_password !== undefined"
            :error-messages="errors.old_password"
          />
          <v-text-field
            required
            name="new_password1"
            label="New Password"
            v-model="formData.new_password1"
            :type="showPassword1 ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword1 = !showPassword1"
            :error="errors.new_password1 !== undefined"
            :error-messages="errors.new_password1"
          />
          <v-text-field
            required
            name="new_password2"
            label="New Password (again)"
            v-model="formData.new_password2"
            :type="showPassword2 ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword2 = !showPassword2"
            :error="errors.new_password2 !== undefined"
            :error-messages="errors.new_password2"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn type="submit" outlined color="success" class="mx-auto">
            <span>Change</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <v-snackbar v-model="snackbar.show" top :timeout="5000">
      {{ snackbar.message }}
      <v-btn color="success" text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PasswordChangeForm",
  components: {},
  data() {
    return {
      formData: {
        old_password: "",
        new_password1: "",
        new_password2: ""
      },
      showOldPassword: false,
      showPassword1: false,
      showPassword2: false,
      snackbar: { show: false, message: "" },
      errors: {}
    };
  },
  methods: {
    ...mapActions("accounts", ["changePassword"]),
    async submit() {
      try {
        let result = await this.changePassword(this.formData);
        this.errors = {};
        this.snackbar.message = result.detail;
        this.snackbar.show = true;
      } catch (e) {
        this.errors = e.response.data;
      }
    }
  }
};
</script>
